import PrivateMenuItem from './PrivateMenuItem'

export default PrivateMenuItem
